/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrow-left-alt': {
    width: 19,
    height: 15,
    viewBox: '0 0 19 15',
    data: '<path pid="0" d="M8.017 13.825a.978.978 0 00-.224-.622L4.01 8.621l13.335.01a.97.97 0 00.963-.971c0-.534-.43-.97-.961-.972l-13.329-.01 3.775-4.574A.98.98 0 007.67.737a.945.945 0 00-.702-.222.95.95 0 00-.652.345L1.222 7.032a.977.977 0 00.001 1.243l5.093 6.172a.95.95 0 00.652.345.94.94 0 00.702-.22.972.972 0 00.347-.747z" _fill="#27DBBD" _stroke="#27DBBD" stroke-width=".2" fill-rule="evenodd"/>'
  }
})
